import type { Card } from '../../types';

export const HEAVY_CLEAVE: Card = {
  id: 'heavy-cleave',
  name: 'Heavy Cleave',
  type: 'attack',
  rarity: 'rare',
  size: { w: 2, h: 2 },
  cost: [
    { kind: 'min', value: 5 },
    { kind: 'min', value: 3 },
  ],
  effects: [{ kind: 'damage', amount: 9 }],
};
